// extracted by mini-css-extract-plugin
module.exports = {"dividerAndButtonGroup":"KJZ6MwQY","verticalDivider":"UV_GRDQJ","styledButton":"OVwHoc6H"};